import './App.css';
import Body from '../components/Body/Body';
import Footer from '../components/Footer/Footer';

function App() {
  return (
    <div>
      
      <Body/>
       <Footer/>    
    </div>
  );
}

export default App;
